module.exports = __webpack_public_path__ + "img/SKMJ_cover1.33be6869.jpg";